module.exports = __webpack_public_path__ + "assets/img/bannerBg.a8e96460.png";